<script setup lang="ts">
defineProps<{
  show: boolean
}>()
</script>

<template>
  <div v-if="show" class="loading-wrapper">
    <div class="ring ring-1"></div>
    <div class="ring ring-2"></div>
    <div class="ring ring-3"></div>
  </div>
</template>

<style scoped>
.loading-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--app-background, #0f172a);
  z-index: 9999;
}

.ring {
  position: absolute;
  border-radius: 50%;
  -webkit-mask: radial-gradient(circle, transparent 60%, black 61%);
  mask: radial-gradient(circle, transparent 60%, black 61%);
}

.ring-1 {
  width: 60px;
  height: 60px;
  background: conic-gradient(
    hsl(var(--loader-ring-1)) 0deg 300deg,
    transparent 300deg 360deg
  );
  animation: spin 1.6s linear infinite;
}

.ring-2 {
  width: 50px;
  height: 50px;
  background: conic-gradient(
    hsl(var(--loader-ring-2)) 0deg 280deg,
    transparent 280deg 360deg
  );
  animation: spinReverse 1.2s linear infinite;
}

.ring-3 {
  width: 40px;
  height: 40px;
  background: conic-gradient(
    hsl(var(--loader-ring-3)) 0deg 260deg,
    transparent 260deg 360deg
  );
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes spinReverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}
</style>
